
var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": null,
    "options": {
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [
        {
            "name": "UserBalanceInfo",
            "fields": [
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "inBill",
                    "id": 1
                },
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "outDiamond",
                    "id": 2
                },
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "bill",
                    "id": 3
                },
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "diamond",
                    "id": 4
                }
            ]
        },
        {
            "name": "ProfileInfo",
            "fields": [
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "uid",
                    "id": 1
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "username",
                    "id": 2
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "upliveCode",
                    "id": 3
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "avatar",
                    "id": 4
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "gender",
                    "id": 5
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "setting",
                    "id": 6
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "password",
                    "id": 7
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "userToken",
                    "id": 8
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "signature",
                    "id": 9
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "grade",
                    "id": 10
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "location",
                    "id": 11
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "mobilePhone",
                    "id": 12
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "fanTotal",
                    "id": 13
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "followTotal",
                    "id": 14
                },
                {
                    "rule": "optional",
                    "type": "UserBalanceInfo",
                    "name": "balance",
                    "id": 15
                },
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "chatroomid",
                    "id": 16
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "followType",
                    "id": 17
                },
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "exp",
                    "id": 18
                },
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "currentExp",
                    "id": 19
                },
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "nextExp",
                    "id": 20
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "officialAuth",
                    "id": 21
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "officialAuthContent",
                    "id": 22
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "qualityAuth",
                    "id": 23
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "countryCode",
                    "id": 25
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "admin",
                    "id": 26
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "userRealNameAuth",
                    "id": 27
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "acceptAgreement",
                    "id": 28
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "upliveCodeStatus",
                    "id": 29
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "subscribe",
                    "id": 30
                },
                {
                    "rule": "repeated",
                    "type": "Source",
                    "name": "sources",
                    "id": 31
                }
            ]
        },
        {
            "name": "Source",
            "fields": [
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "bindType",
                    "id": 1
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "openId",
                    "id": 2
                }
            ]
        },
        {
            "name": "ThirdCheck",
            "fields": [],
            "messages": [
                {
                    "name": "Register",
                    "fields": [],
                    "options": {
                        "objc_class_prefix": "ThirdCheckRegister",
                        "java_package": "com.asiainno.uplive.proto"
                    },
                    "messages": [
                        {
                            "name": "Request",
                            "fields": [
                                {
                                    "rule": "optional",
                                    "type": "BindType",
                                    "name": "bindType",
                                    "id": 1
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "thirdId",
                                    "id": 2
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "thirdToken",
                                    "id": 3
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "extension",
                                    "id": 4
                                },
                                {
                                    "rule": "optional",
                                    "type": "int32",
                                    "name": "gender",
                                    "id": 5
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "mobilePhone",
                                    "id": 6
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "username",
                                    "id": 7
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "signature",
                                    "id": 8
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "avatar",
                                    "id": 9
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "location",
                                    "id": 10
                                },
                                {
                                    "rule": "optional",
                                    "type": "PushType",
                                    "name": "pushType",
                                    "id": 11
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "pushToken",
                                    "id": 12
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "deviceId",
                                    "id": 13
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "smsCode",
                                    "id": 14
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "countryCode",
                                    "id": 16
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "password",
                                    "id": 17
                                },
                                {
                                    "rule": "optional",
                                    "type": "int32",
                                    "name": "bind",
                                    "id": 18
                                }
                            ]
                        },
                        {
                            "name": "Response",
                            "fields": [
                                {
                                    "rule": "optional",
                                    "type": "ProfileInfo",
                                    "name": "profile",
                                    "id": 1
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "exmailCheckCode",
                                    "id": 2
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "enums": [
        {
            "name": "BindType",
            "values": [
                {
                    "name": "DEFAULT_TYPE",
                    "id": 0
                },
                {
                    "name": "MOBILE_PHONE",
                    "id": 1
                },
                {
                    "name": "QQ",
                    "id": 2
                },
                {
                    "name": "WEIXIN",
                    "id": 3
                },
                {
                    "name": "FACEBOOK",
                    "id": 4
                },
                {
                    "name": "SINA_WEIBO",
                    "id": 5
                },
                {
                    "name": "RR",
                    "id": 6
                },
                {
                    "name": "TENCENT_WANBA",
                    "id": 7
                },
                {
                    "name": "KECHENGGEZI",
                    "id": 8
                },
                {
                    "name": "DEVICE",
                    "id": 9
                },
                {
                    "name": "GOOGLE",
                    "id": 15
                },
                {
                    "name": "TWITTER",
                    "id": 16
                },
                {
                    "name": "EMAIL",
                    "id": 17
                }
            ]
        },
        {
            "name": "PushType",
            "values": [
                {
                    "name": "DEFAULT_PUSHTYPE",
                    "id": 0
                },
                {
                    "name": "BAIDU",
                    "id": 1
                },
                {
                    "name": "IOS",
                    "id": 2
                },
                {
                    "name": "JPUSH",
                    "id": 3
                },
                {
                    "name": "XIAOMI",
                    "id": 4
                },
                {
                    "name": "GETUI",
                    "id": 5
                },
                {
                    "name": "GOOGLE_PUSH",
                    "id": 6
                },
                {
                    "name": "SAMSUNG",
                    "id": 7
                },
                {
                    "name": "MEIZU",
                    "id": 8
                },
                {
                    "name": "HUAWEI",
                    "id": 9
                },
                {
                    "name": "GOOGLE_FCM",
                    "id": 10
                }
            ]
        }
    ]
}).build();

export default _root;


// WEBPACK FOOTER //
// ./js/component/openjs/deps/login/thirdparty/register.pb.js